export const heroData = {
  tag: "🔥 全网最活跃",
  h1: "51大赛 — 最火爆的大赛讨论社区",
  slogan: "内幕早知道，八卦不停歇",
  description: "51大赛是汇聚全国赛事爱好者的头部讨论社区，覆盖综艺选秀、电竞赛事、学科竞赛、创新创业大赛等全品类赛事话题。每天数万条新鲜讨论，从赛前预测到赛后复盘，从业内爆料到选手八卦，你关心的赛事内幕这里都有。社区坚持开放、即时、真实的讨论氛围，让你第一时间掌握赛事风向与圈内动态。",
  stats: [
    { value: "12.8万+", label: "日活讨论用户" },
    { value: "360+", label: "覆盖赛事品类" },
    { value: "24h", label: "内幕实时更新" },
  ],
  cta_primary: { text: "立即加入讨论", href: "#topics" },
  cta_secondary: { text: "了解社区", href: "#about" },
};

export const appData = {
  title: "51大赛手机端",
  description: "随时随地刷赛事内幕，手机端访问体验已全面适配。打开浏览器直接访问即可畅享全部功能，收藏本站不迷路。",
  features: ["极速浏览", "实时推送", "一键参与"],
};

export const aboutData = {
  title: "关于51大赛",
  content: "51大赛是国内领先的综合性赛事讨论社区，创立以来始终聚焦各类竞赛活动的话题交流与内幕分享。我们汇聚了来自综艺、电竞、体育、学术、创业等领域的资深赛事观察者和热情讨论者，构建了一个开放、真实、有温度的赛事交流平台。无论是想了解最新赛况、挖掘独家内幕，还是寻找志同道合的赛友一起讨论，51大赛都是你的不二之选。",
  highlights: [
    { icon: "ri-user-star-line", label: "真人讨论", desc: "拒绝水军，真实用户交流" },
    { icon: "ri-shield-check-line", label: "信息可靠", desc: "多方交叉验证信息来源" },
    { icon: "ri-fire-line", label: "热点追踪", desc: "24小时全网赛事监控" },
    { icon: "ri-group-line", label: "社区氛围", desc: "友好开放的讨论环境" },
  ],
};

export const faqData = [
  { q: "51大赛社区主要讨论哪些类型的赛事？", a: "我们的讨论范围涵盖综艺选秀、电竞赛事、学科竞赛、体育赛事、创新创业大赛等几乎所有品类。从《歌手》《创造营》等热门综艺到LPL、KPL等电竞赛事，从数学建模到互联网+创业大赛，你想讨论的赛事这里都有人在聊。" },
  { q: "如何参与社区讨论？需要注册吗？", a: "目前社区以浏览和阅读为主，你可以直接查看所有公开话题和讨论内容。完整的发帖和评论功能即将上线，届时只需简单注册即可参与互动，与数万赛友一起畅聊赛事内幕。" },
  { q: "社区的内幕信息来源可靠吗？", a: "51大赛社区采用多重信息交叉验证机制，热门内幕帖会被标记「待核实」或「已确认」状态。我们鼓励用户标注信息来源，并对恶意造谣内容采取零容忍态度，确保讨论质量。" },
  { q: "为什么叫51大赛？有什么特殊含义吗？", a: "「51」谐音「我要」，寓意「我要参赛、我要讨论」的热情态度。同时5月1日也是劳动节，象征着我们社区勤劳更新的运营理念——每天都有新鲜赛事内容等你来发现。" },
  { q: "如何获取最新的赛事内幕和热门话题推送？", a: "你可以将51大赛添加到浏览器收藏夹，或使用手机浏览器访问我们的移动适配版。我们计划推出消息推送功能，让你不错过任何一个赛事热点。关注首页「最新动态」模块也能第一时间看到更新。" },
];

export const carouselData = [
  { title: "《歌手2026》突围赛内幕", tag: "综艺", desc: "知情人士透露本季突围赛赛制重大调整，三名往季选手或受邀回归", imageSeq: "carousel-01" },
  { title: "LPL夏季赛转会期重磅爆料", tag: "电竞", desc: "多支战队正秘密接触顶级韩援，下赛季格局或将彻底洗牌", imageSeq: "carousel-02" },
  { title: "全国数学建模大赛命题方向预测", tag: "学术", desc: "多位高校教练分析今年命题趋势，AI应用或成核心考察点", imageSeq: "carousel-03" },
  { title: "创新创业大赛冠军项目复盘", tag: "创业", desc: "去年国赛金奖团队首次公开路演细节与评委反馈，干货满满", imageSeq: "carousel-04" },
  { title: "NBA夏季联赛中国球员表现追踪", tag: "体育", desc: "三位中国球员征战夏季联赛，详细数据与球探报告独家汇总", imageSeq: "carousel-05" },
  { title: "《创造营2026》选手背景大起底", tag: "综艺", desc: "练习生履历深度挖掘，多位选手背后竟有这些不为人知的故事", imageSeq: "carousel-06" },
];

export const contactData = {
  title: "联系我们",
  description: "如果你有赛事内幕线索、独家爆料，或者对社区有任何建议和意见，欢迎通过以下方式联系我们。我们重视每一条来自赛友的声音。",
  items: [
    { icon: "ri-mail-line", label: "投稿邮箱", value: "tips@51dasai.com" },
    { icon: "ri-wechat-line", label: "微信公众号", value: "51大赛社区" },
    { icon: "ri-chat-smile-2-line", label: "合作联系", value: "coop@51dasai.com" },
  ],
};

export const commentsData = [
  { author: "赛圈老炮儿", avatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20avatar%20portrait%20casual%20style%20warm%20background%20simple%20minimal%20professional&width=80&height=80&seq=avatar-1&orientation=squarish", date: "2小时前", content: "在这个社区蹲了半年了，内幕消息确实比别的地方快。上次歌手突围赛的名单，这边提前三天就有人曝了，还全中了，服气。", likes: 1283 },
  { author: "电竞观察家", avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20avatar%20portrait%20modern%20style%20clean%20warm%20background%20minimal&width=80&height=80&seq=avatar-2&orientation=squarish", date: "5小时前", content: "LPL转会期的料太猛了，每天刷好几次生怕错过。建议加一个「转会追踪」专题，把各战队动态汇总起来。", likes: 967 },
  { author: "数学建模小能手", avatar: "https://readdy.ai/api/search-image?query=Chinese%20female%20student%20avatar%20portrait%20friendly%20warm%20background%20simple%20clean&width=80&height=80&seq=avatar-3&orientation=squarish", date: "8小时前", content: "刚参加完数模国赛，来社区看复盘分析真的受益匪浅。前辈们的解题思路和论文框架分享太有用了！", likes: 745 },
  { author: "综艺八卦王", avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20avatar%20trendy%20style%20warm%20simple%20background%20minimal&width=80&height=80&seq=avatar-4&orientation=squarish", date: "12小时前", content: "创造营那个帖子笑死我了，楼主扒练习生背景扒得比节目组还详细。这种深度的八卦才是我们想看的！", likes: 1532 },
  { author: "赛事资讯通", avatar: "https://readdy.ai/api/search-image?query=Chinese%20male%20avatar%20portrait%20mature%20professional%20warm%20background%20simple%20minimal&width=80&height=80&seq=avatar-5&orientation=squarish", date: "1天前", content: "作为老用户提个建议：希望能在话题下面加个「相关赛事」的入口，方便一键跳转。不过整体已经很满意了。", likes: 521 },
];

export const updatesData = [
  { date: "07-30", time: "14:22", title: "《歌手2026》突围赛名单疑似泄露，三位往季歌手确认回归", tag: "爆料", hot: true },
  { date: "07-30", time: "11:08", title: "LPL夏季赛季后赛赛程正式公布，八强对阵出炉", tag: "官宣", hot: true },
  { date: "07-30", time: "09:45", title: "全国大学生数学建模竞赛报名人数创历史新高", tag: "资讯", hot: false },
  { date: "07-29", time: "20:30", title: "某顶流综艺导师阵容内部讨论稿流出，阵容豪华", tag: "内幕", hot: true },
  { date: "07-29", time: "16:15", title: "NBA夏季联赛中国球员场均数据排名出炉", tag: "数据", hot: false },
  { date: "07-29", time: "10:50", title: "创新创业大赛国赛评审标准调整，社会影响力权重提升", tag: "政策", hot: false },
  { date: "07-28", time: "22:18", title: "KPL夏季赛某战队教练组大换血内幕细节曝光", tag: "内幕", hot: true },
  { date: "07-28", time: "15:40", title: "全国青少年编程大赛初赛题目难度引发家长热议", tag: "讨论", hot: false },
];

export const indexData = [
  { title: "综艺赛事专区", desc: "歌手、创造营、好声音等热门综艺赛况追踪", icon: "ri-tv-line", count: "2.3万帖" },
  { title: "电竞赛事大厅", desc: "LPL、KPL、PEL等顶级电竞赛事深度讨论", icon: "ri-gamepad-line", count: "5.1万帖" },
  { title: "学科竞赛园地", desc: "数模、编程、英语、物理等学科竞赛交流", icon: "ri-book-open-line", count: "1.8万帖" },
  { title: "体育赛事看台", desc: "NBA、中超、CBA、五大联赛赛事热评", icon: "ri-basketball-line", count: "3.6万帖" },
  { title: "创新创业广场", desc: "互联网+、挑战杯、创青春等创业赛事分享", icon: "ri-lightbulb-line", count: "9.2千帖" },
  { title: "选秀练习生圈", desc: "各类选秀节目选手追踪与练习生动态", icon: "ri-star-line", count: "4.7万帖" },
  { title: "赛事八卦茶馆", desc: "圈内爆料、选手日常、幕后故事一网打尽", icon: "ri-chat-smile-2-line", count: "6.8万帖" },
];

export const cardsData = [
  { title: "《歌手2026》首发阵容全解析", category: "综艺", imageSeq: "card-01", desc: "从资历、唱功、人气三维度深度解析本季首发歌手配置", heat: "9.8万热度" },
  { title: "LPL转会期：谁将成为最大赢家？", category: "电竞", imageSeq: "card-02", desc: "各战队引援策略对比分析，新赛季实力格局预测", heat: "7.2万热度" },
  { title: "全国数模大赛获奖论文精读", category: "学术", imageSeq: "card-03", desc: "国奖团队的建模思路与论文框架逐段拆解", heat: "3.5万热度" },
  { title: "NBA夏季联赛：中国球员前景分析", category: "体育", imageSeq: "card-04", desc: "逐场数据复盘，下赛季留队概率与潜力评估", heat: "5.6万热度" },
  { title: "创青春创业大赛路演技巧大全", category: "创业", imageSeq: "card-05", desc: "评委最看重的五个维度及高分路演PPT模板分享", heat: "4.1万热度" },
  { title: "KPL夏季赛黑马战队深度观察", category: "电竞", imageSeq: "card-06", desc: "从数据到战术全面剖析本赛季最大黑马的崛起之路", heat: "6.3万热度" },
];

export const featuresData = [
  { icon: "ri-flashlight-line", title: "内幕首发", desc: "赛事内幕消息全网最快曝光，多位前线线人实时供稿，确保你比99%的人更早知道真相。" },
  { icon: "ri-discuss-line", title: "深度讨论", desc: "每一条爆料都伴随高质量的分析讨论，资深赛友从多角度拆解信息，拒绝标题党和断章取义。" },
  { icon: "ri-archive-line", title: "信息沉淀", desc: "热门话题自动归档整理，即使错过实时讨论也能通过专题合集快速回顾全部来龙去脉。" },
];

export const topicsData = [
  { name: "歌手2026", heat: "128万", posts: 56320, tag: "爆" },
  { name: "LPL夏季赛", heat: "96万", posts: 42180, tag: "热" },
  { name: "创造营2026", heat: "87万", posts: 38950, tag: "热" },
  { name: "数模国赛", heat: "45万", posts: 18230, tag: "" },
  { name: "NBA中国赛", heat: "52万", posts: 23450, tag: "新" },
  { name: "KPL夏季赛", heat: "41万", posts: 17680, tag: "" },
  { name: "青创大赛", heat: "33万", posts: 14200, tag: "" },
  { name: "好声音2026", heat: "38万", posts: 15940, tag: "新" },
  { name: "编程马拉松", heat: "29万", posts: 12360, tag: "" },
  { name: "中超联赛", heat: "47万", posts: 20150, tag: "热" },
  { name: "挑战杯", heat: "26万", posts: 10890, tag: "" },
];

export const mediaData = [
  { title: "《歌手2026》首发竞演全记录", duration: "45:22", views: "128万", imageSeq: "media-01" },
  { title: "LPL夏季赛十大名场面盘点", duration: "32:18", views: "96万", imageSeq: "media-02" },
  { title: "数模国赛优秀论文答辩现场", duration: "28:05", views: "53万", imageSeq: "media-03" },
];

export const rankingData = [
  { rank: 1, title: "《歌手2026》突围赛名单爆料帖", category: "综艺", heat: "156万热度", trend: "up", change: "+32%" },
  { rank: 2, title: "LPL转会期各战队操作评级", category: "电竞", heat: "132万热度", trend: "up", change: "+28%" },
  { rank: 3, title: "创造营选手背景深度挖掘（持续更新）", category: "综艺", heat: "118万热度", trend: "up", change: "+45%" },
  { rank: 4, title: "数模国赛命题趋势与备赛策略", category: "学术", heat: "87万热度", trend: "stable", change: "+5%" },
  { rank: 5, title: "NBA夏季联赛中国球员每日追踪", category: "体育", heat: "76万热度", trend: "down", change: "-12%" },
  { rank: 6, title: "KPL某战队内部矛盾全记录", category: "电竞", heat: "72万热度", trend: "up", change: "+18%" },
];

export const footerData = {
  description: "51大赛 — 国内领先的综合性赛事讨论社区。覆盖综艺、电竞、体育、学术、创业等全品类赛事，汇聚最及时的赛事内幕与最热烈的赛友讨论。",
  links: [
    { label: "关于我们", href: "#about" },
    { label: "常见问题", href: "#faq" },
    { label: "最新动态", href: "#updates" },
    { label: "热门话题", href: "#topics" },
    { label: "联系我们", href: "#contact" },
  ],
};